import { useQuery } from '@tanstack/react-query';

import { useIamApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { CloudUserInfo } from '../constants';

type UseUserInfoOptions = UseQueryOptions<CloudUserInfo>;

/**
 * 현재 사용자의 정보를 제공하는 훅입니다.
 * @description
 * - IAM Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - staleTime: Infinity로 자동 재요청을 방지하며, 수동 refetch 시에만 최신 데이터를 조회합니다.
 */
const useUserInfoState = (options?: UseUserInfoOptions) => {
  const { fetchCloudUserInfo } = useIamApiInstance();

  return useQuery<CloudUserInfo>({
    queryKey: [HOST_QUERY_KEY.GET_IAM_ACCESS_TOKEN],
    queryFn: () => fetchCloudUserInfo({}),
    staleTime: Infinity,
    ...options,
  });
};

export default useUserInfoState;
